/** Dashboard / public surface that owns a component row store. */
export type ComponentSurface =
  | "landing-page"
  | "embed-search"
  | "website-template";

export const WEBSITE_TEMPLATE_SURFACE: ComponentSurface = "website-template";

export const TEMPLATE_COMPONENTS_TABLE = "template_components" as const;

export type ComponentsTableName =
  | "stayuptodate_components"
  | "embed_components"
  | typeof TEMPLATE_COMPONENTS_TABLE;

/** Maps a `from` surface to its Supabase components table. */
export function getComponentsTableName(
  from?: string | null,
): ComponentsTableName {
  if (from === "embed-search") return "embed_components";
  if (from === WEBSITE_TEMPLATE_SURFACE) return TEMPLATE_COMPONENTS_TABLE;
  return "stayuptodate_components";
}

export function isWebsiteTemplateSurface(from?: string | null): boolean {
  return from === WEBSITE_TEMPLATE_SURFACE;
}

/** `user_links.type` value for website template link collections. */
export function getUserLinksTypeForSurface(
  from?: string | null,
): "landing-page" | "embed-search" | "website-template" {
  if (from === "embed-search") return "embed-search";
  if (from === WEBSITE_TEMPLATE_SURFACE) return "website-template";
  return "landing-page";
}
